import React from "react";
import styles from './BookSearchCompactItem.module.css';

const BookSearchCompactItem = ({ item, onHandleDelete }) => {

  return (
    <div key={item.bookid} className={styles.bookItem}>
      <div>
        {item.authors && item.authors.map((item) => <React.Fragment>{item.name}, </React.Fragment>)|| 'Не указано'} <b>{item.title || '-'}</b>
        {item.publishers && item.publishers.map(item => <React.Fragment>{item.name}, </React.Fragment>)|| 'Не указано'}
        <i>{!!item.pageNum && `${item.pageNum}стр.`}</i>
      </div>
      <p className={'d-flex justify-content-end mt-1 mb-0'}>
        {onHandleDelete ? <button onClick={() => onHandleDelete(item.id)} className="btn">
          Удалить
        </button> : null}
      </p>
    </div>
  );
};

export default BookSearchCompactItem;